import { ApiProperty } from "@nestjs/swagger";

export class PPMExcelUploadDto {
    // DPOM API Data
    @ApiProperty()
    bomItem: string;
    @ApiProperty()
    documentDate: string;
    @ApiProperty()
    purchaseOrderNumber: string;
    @ApiProperty()
    poLineItemNumber: number;
    // @ApiProperty()
    // scheduleLineItemNumber: string;
    @ApiProperty()
    productCode: string;
    @ApiProperty()
    sizeDescription: string;
    @ApiProperty()
    sizeQuantity: number;
    @ApiProperty()
    destinationCountry: string;
    @ApiProperty()
    DPOMLineItemStatus: string;
    @ApiProperty()
    styleNumber: string;
    @ApiProperty()
    colorDesc: string;
    @ApiProperty()
    planningSeasonCode: string;
    @ApiProperty()
    planningSeasonYear: string;
    @ApiProperty()
    plant: string;
    @ApiProperty()
    OGAC: string;
    @ApiProperty()
    GAC: string;
    @ApiProperty()
    shippingType: string;
    @ApiProperty()
    totalItemQty: string;
    @ApiProperty()
    geoCode: string;
    @ApiProperty()
    shipToCustomerNumber: string;
    @ApiProperty()
    shipToCustomerName: string;
    @ApiProperty()
    customerPO: string;
    @ApiProperty()
    directShipSONumber: string;
    @ApiProperty()
    directShipSOItemNumber: string;
    @ApiProperty()
    inventorySegmentCode: string;
    @ApiProperty()
    VASSize: string;
    @ApiProperty()
    itemVasText: string;
    @ApiProperty()
    genderAgeDesc: string;
    @ApiProperty()
    productName: string;
    @ApiProperty()
    poAndLine: string;
    @ApiProperty()
    createdUser?: string;
    @ApiProperty()
    odVersion?: number;
    @ApiProperty()
    fileId?: number;

    constructor(bomItem: string, documentDate: string, purchaseOrderNumber: string, poLineItemNumber: number, productCode: string,
        sizeDescription: string, sizeQuantity: number, destinationCountry: string, DPOMLineItemStatus: string, styleNumber: string,
        colorDesc: string, planningSeasonCode: string, planningSeasonYear: string, plant: string, OGAC: string, GAC: string,
        shippingType: string, totalItemQty: string, geoCode: string, shipToCustomerNumber: string, shipToCustomerName: string,
        customerPO: string, directShipSONumber: string, directShipSOItemNumber: string, inventorySegmentCode: string, VASSize: string,
        itemVasText: string, genderAgeDesc: string, productName: string, poAndLine: string, createdUser?: string, odVersion?: number, fileId?: number

    ) {
        this.bomItem = bomItem
        this.documentDate = documentDate
        this.purchaseOrderNumber = purchaseOrderNumber
        this.poLineItemNumber = poLineItemNumber
        this.styleNumber = styleNumber
        this.productCode = productCode
        this.colorDesc = colorDesc
        this.destinationCountry = destinationCountry
        this.plant = plant
        this.directShipSONumber = directShipSONumber
        this.directShipSOItemNumber = directShipSOItemNumber
        this.customerPO = customerPO
        this.shipToCustomerNumber = shipToCustomerNumber
        this.shipToCustomerName = shipToCustomerName
        this.planningSeasonCode = planningSeasonCode
        this.planningSeasonYear = planningSeasonYear
        this.OGAC = OGAC
        this.GAC = GAC
        this.shippingType = shippingType
        this.geoCode = geoCode
        this.DPOMLineItemStatus = DPOMLineItemStatus
        this.inventorySegmentCode = inventorySegmentCode
        this.totalItemQty = totalItemQty
        this.VASSize = VASSize
        this.sizeQuantity = sizeQuantity
        this.sizeDescription = sizeDescription
        this.itemVasText = itemVasText
        this.genderAgeDesc = genderAgeDesc
        this.productName = productName
        this.poAndLine = poAndLine
        this.createdUser = createdUser
        this.odVersion = odVersion
        this.fileId = fileId;
    }
}
